import { render } from "./DetailText.vue?vue&type=template&id=bae1bcd0&scoped=true"
import script from "./DetailText.vue?vue&type=script&lang=js"
export * from "./DetailText.vue?vue&type=script&lang=js"

import "./DetailText.vue?vue&type=style&index=0&id=bae1bcd0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae1bcd0"]])

export default __exports__